"use client";

import { useEffect } from "react";
import { setupGlobalChunkErrorHandler } from "@/utils/chunkErrorHandler";

/**
 * ChunkErrorHandlerInit Component
 * Initializes the global chunk error handler on the client side
 * Must be included early in the app to catch chunk loading errors
 */
export default function ChunkErrorHandlerInit() {
  useEffect(() => {
    // Initialize the global chunk error handler
    setupGlobalChunkErrorHandler();

    // Mark handler as ready
    if (typeof window !== "undefined") {
      window.__chunkErrorHandlerReady__ = true;

      // Process any pending errors that were queued during early initialization
      const pendingErrors = window.__pendingChunkErrors__ || [];
      if (pendingErrors.length > 0) {
        console.log(
          `🔄 Processing ${pendingErrors.length} pending chunk error(s)`
        );

        // Import handler and process errors
        import("@/utils/chunkErrorHandler").then(({ default: handler }) => {
          pendingErrors.forEach((error) => {
            handler.handleChunkError(error).catch((err) => {
              console.error("Failed to handle pending chunk error:", err);
            });
          });

          // Clear pending errors
          window.__pendingChunkErrors__ = [];
        });
      }
    }
  }, []);

  // This component doesn't render anything
  return null;
}

